export const providersUrl: { [key: string]: string } = {
  1: "https://eth.drpc.org",
  31337: "http://127.0.0.1:8545",
};

export const explorersUrl: { [key: string]: string } = {
  1: "https://etherscan.io",
  31337: "http://127.0.0.1:8545",
};
